import naja from "naja";

export default class BookingReservationForm {
    static init(): void {
        const forms = document.querySelectorAll('.booking-reservation-form') as NodeListOf<HTMLFormElement>;

        forms.forEach((form) => {
            const parents = form.querySelectorAll('.booking-reservation-form__parent');

            parents.forEach((parent) => {
                // INPUTS
                const input = parent.querySelector('input, textarea') as HTMLInputElement;
                if (!input) return;

                input.addEventListener('focus', () => {
                    parent.classList.add('booking-reservation-form__parent--active');
                });

                input.addEventListener('blur', () => {
                    parent.classList.remove('booking-reservation-form__parent--active');
                    if (input.value !== '') {
                        parent.classList.add('booking-reservation-form__parent--filled');
                    } else {
                        parent.classList.remove('booking-reservation-form__parent--filled');
                    }

                    // ERROR MESSAGE
                    const rules = input.getAttribute('data-nette-rules');
                    if (rules) {
                        const rulesArray: { op: string, msg: string, arg?: string }[] = JSON.parse(rules);
                        rulesArray.forEach((rule) => {
                            let errorMessageElement = parent.querySelector('.booking-reservation-form__error-message');
                            if (!errorMessageElement) {
                                errorMessageElement = document.createElement('div');
                                errorMessageElement.classList.add('booking-reservation-form__error-message');
                                parent.appendChild(errorMessageElement);
                            }

                            if (rule.op === ':pattern') {
                                errorMessageElement.innerHTML = rule.msg;
                                const pattern = new RegExp('^' + rule.arg + '$');
                                if (!pattern.test(input.value)) {
                                    parent.classList.add('booking-reservation-form__parent--error');
                                } else {
                                    parent.classList.remove('booking-reservation-form__parent--error');
                                    errorMessageElement.remove();
                                }
                            }
                        });
                    }
                });
            });


            // RADIO BUTTONS
            const radioButtons = form.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
            radioButtons.forEach((radioButton) => {
                const parent = radioButton.closest('.booking-reservation-form__radio-parent');

                parent?.addEventListener('click', () => {
                    radioButtons.forEach((radioButton) => {
                        const parent = radioButton.closest('.booking-reservation-form__radio-parent');
                        if (!parent) return;
                        parent.classList.remove('booking-reservation-form__radio-parent--active');
                        parent.classList.remove('booking-reservation-form__radio-parent--error');
                    });
                    parent?.classList.add('booking-reservation-form__radio-parent--active');
                    radioButton.checked = true;
                });
            });

            // SUMMARY
            const summary = document.querySelector('.booking-reservation__summary');
            if (!summary) return;

            const payInAdvance = summary.querySelector('#booking-reservation__summary-payInAdvance') as HTMLInputElement | null;
            const payInAdvanceLabel = payInAdvance?.closest('label') as HTMLElement | null;
            const payInAdvanceFormInput = form.querySelector('#frm-bookingForm-form-payInAdvance') as HTMLInputElement;
            if (payInAdvance && payInAdvanceFormInput) {

                payInAdvance.addEventListener('click', () => {
                    calculateTotalPrice();
                });


                // ADDITIONAL SERVICES
                const additionalServices = form.querySelectorAll('#booking-reservation-form__additionalServices input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
                additionalServices.forEach((checkbox) => {
                    checkbox.addEventListener('change', () => {
                        calculateTotalPrice();
                    });
                });

                // ADDITIONAL SERVICES - MULTIROOM RESERVATION
                const additionalServicesSelects = form.querySelectorAll('#booking-reservation-form__additionalServices select') as NodeListOf<HTMLSelectElement>;
                additionalServicesSelects.forEach((select) => {
                    select.addEventListener('change', () => {
                        calculateTotalPrice();
                    });
                });

                const additionalServicesCheckbox = form.querySelector('#frm-bookingForm-form-additionalCheckbox') as HTMLInputElement;
                if (additionalServicesCheckbox) {
                    additionalServicesCheckbox.addEventListener('click', () => {
                        additionalServices.forEach((checkbox) => {
                            if (!additionalServicesCheckbox.checked) {
                                checkbox.checked = false;
                            }
                        });
                        additionalServicesSelects.forEach((select) => {
                            if (!additionalServicesCheckbox.checked) {
                                select.value = '0';
                            } else {

                            }
                        });
                        calculateTotalPrice();
                    });
                }
            }

            // USE VOUCHER
            const useVoucher = summary.querySelector('#booking-reservation__summary-useVoucher') as HTMLInputElement | null;
            const voucherHiddenInput = form.querySelector('#frm-bookingForm-form-voucherCode') as HTMLInputElement | null;
            if (useVoucher && voucherHiddenInput) {
                const voucherInput = summary.querySelector('#booking-reservation__summary-voucher-code') as HTMLInputElement;
                const voucherInputParent = voucherInput.closest('.booking-reservation__summary-voucher') as HTMLElement;
                const voucherButton = voucherInputParent.querySelector('#booking-reservation__summary-voucher-button') as HTMLElement;
                const voucherMessage = summary.querySelector('#booking-reservation__summary-voucher-message') as HTMLElement;

                useVoucher.addEventListener('click', () => {
                    if (useVoucher.checked) {
                        voucherInputParent?.classList.add('booking-reservation__summary-voucher--active');
                        voucherInput.focus();
                    } else {
                        voucherInputParent?.classList.remove('booking-reservation__summary-voucher--active');
                    }
                });

                voucherButton.addEventListener('click', () => {
                    const voucherCode = voucherInput.value;
                    if (voucherCode === '') {
                        voucherMessage.innerHTML = 'Zadejte kód poukazu';
                        voucherMessage.classList.remove('text-success');
                        voucherMessage.classList.add('text-danger');
                        return;
                    }

                    const url = voucherButton.getAttribute('data-action') as string;
                    if (!url) return;

                    const ajaxSpinner = document.querySelector('.ajax-spinner') as HTMLElement;
                    ajaxSpinner?.classList.add('ajax-spinner--show');

                    naja.makeRequest('POST', url, {voucherCode: voucherCode}, {
                        history: false,
                    }).then((response) => {
                        voucherMessage.innerHTML = response.message;
                        voucherInput.dataset.voucherAmount = response.amount;
                        voucherHiddenInput.value = voucherCode;

                        if (response.success) {
                            voucherMessage.classList.remove('text-danger');
                            voucherMessage.classList.add('text-success');
                        } else {
                            voucherMessage.classList.remove('text-success');
                            voucherMessage.classList.add('text-danger');
                        }

                        calculateTotalPrice();
                        ajaxSpinner?.classList.remove('ajax-spinner--show');
                    });

                });
            }

            // MULTIROOM RESERVATION
            let roomCount = 1;
            const roomCountSelect = summary.querySelector('#booking-reservation__summary-roomCount') as HTMLSelectElement | null;
            const roomCountFormInput = form.querySelector('#frm-bookingForm-form-roomCount') as HTMLInputElement | null;

            if (roomCountSelect && roomCountFormInput) {
                roomCount = parseInt(roomCountSelect.value);
                calculateTotalPrice();

                roomCountSelect.addEventListener('change', () => {
                    roomCount = parseInt(roomCountSelect.value);
                    roomCountFormInput.value = roomCount.toString();

                    // add to additionalServicesSelects select new options
                    const additionalServicesSelects = form.querySelectorAll('#booking-reservation-form__additionalServices select') as NodeListOf<HTMLSelectElement>;
                    additionalServicesSelects.forEach((select) => {
                        const options = select.querySelectorAll('option') as NodeListOf<HTMLOptionElement>;
                        options.forEach((option) => {
                            option.remove();
                        });

                        for (let i = 0; i <= roomCount; i++) {
                            const option = document.createElement('option');
                            option.value = i.toString();
                            option.innerHTML = i.toString();
                            select.appendChild(option);
                            console.log(i);
                            if (i === 0) {
                                option.setAttribute('selected', 'selected');
                            }
                        }
                    });

                    const url = roomCountSelect.getAttribute('data-action') as string;
                    if (!url) return;

                    const ajaxSpinner = document.querySelector('.ajax-spinner') as HTMLElement;
                    ajaxSpinner?.classList.add('ajax-spinner--show');

                    naja.makeRequest('POST', url, {roomCount: roomCount}, {
                        history: false,
                    }).then((response) => {
                        roomCountSelect.dataset.multiroomPrices = JSON.stringify(response.prices);
                        ajaxSpinner?.classList.remove('ajax-spinner--show');
                        calculateTotalPrice();
                    });
                });
            }

            // PAYMENT
            function calculateTotalPrice() {
                const summary = document.querySelector('.booking-reservation__summary');
                if (!summary) return;
                let depositPrice = summary.querySelector('[data-booking-deposit-price]') as HTMLElement;
                let onsitePrice = summary.querySelector('[data-booking-onsite-price]') as HTMLElement;
                let totalPrice = summary.querySelector('[data-booking-total-price]') as HTMLElement;
                let depositPriceValue = parseInt(depositPrice.getAttribute('data-booking-deposit-price') as string);
                let onsitePriceValue = parseInt(onsitePrice.getAttribute('data-booking-onsite-price') as string);
                let totalPriceValue = parseInt(totalPrice.getAttribute('data-booking-total-price') as string);
                const voucherMessage = summary.querySelector('#booking-reservation__summary-voucher-message') as HTMLElement;

                // get float value data-booking-deposit-ratio from depositPrice
                let depositRation = parseFloat(depositPrice.getAttribute('data-booking-deposit-ratio') as string);
                let onsiteRation = parseFloat(onsitePrice.getAttribute('data-booking-onsite-ratio') as string);

                if (roomCount > 1 && roomCountSelect?.dataset.multiroomPrices) {
                    const multiroomPrices = JSON.parse(roomCountSelect.dataset.multiroomPrices);
                    totalPriceValue = multiroomPrices.reduce((a: number, b: number) => a + b, 0);
                    depositPriceValue = depositRation * totalPriceValue;
                    onsitePriceValue = onsiteRation * totalPriceValue;
                }

                let days = 1;
                if (totalPrice.getAttribute('data-booking-days')) {
                    days = parseInt(totalPrice.getAttribute('data-booking-days') as string);
                }

                let discountValue = 0;
                if (payInAdvance) {
                    discountValue = parseFloat(payInAdvance.getAttribute('data-discount') as string);
                }

                const additionalServices = form.querySelectorAll('#booking-reservation-form__additionalServices input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
                additionalServices.forEach((checkbox) => {
                    if (checkbox.checked) {
                        depositPriceValue += parseInt(checkbox.getAttribute('data-price') as string) * depositRation * days;
                        onsitePriceValue += parseInt(checkbox.getAttribute('data-price') as string) * onsiteRation * days;
                        totalPriceValue += parseInt(checkbox.getAttribute('data-price') as string) * days;
                    }
                });

                const additionalServicesSelects = form.querySelectorAll('#booking-reservation-form__additionalServices select') as NodeListOf<HTMLSelectElement>;
                additionalServicesSelects.forEach((select) => {
                    const price = select.getAttribute('data-price');
                    const value = parseInt(select.value) * parseInt(price as string);
                    depositPriceValue += value * depositRation * days;
                    onsitePriceValue += value * onsiteRation * days;
                    totalPriceValue += value * days;
                });



                // VOUCHER
                let voucherAmountValue = 0;
                if (voucherHiddenInput && voucherHiddenInput.value !== '' && voucherMessage.classList.contains('text-success')) {
                    const voucherInput = summary.querySelector('#booking-reservation__summary-voucher-code') as HTMLInputElement;
                    const voucherAmount = voucherInput.dataset.voucherAmount;
                    const voucherPrice = summary.querySelector('[data-booking-voucher-price]') as HTMLElement;
                    const voucherPriceRow = voucherPrice.closest('.row') as HTMLElement;

                    if (voucherAmount) {
                        voucherPrice.innerHTML = voucherAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        voucherPriceRow.classList.remove('d-none');

                        voucherAmountValue = parseInt(voucherAmount);
                        depositPriceValue = depositPriceValue - (voucherAmountValue * depositRation);
                        onsitePriceValue = onsitePriceValue - (voucherAmountValue * onsiteRation);
                        totalPriceValue = totalPriceValue - voucherAmountValue;
                    }
                }

                // SLEVA
                if (payInAdvance && payInAdvance.checked) {
                    payInAdvanceFormInput.value = '1';

                    totalPriceValue = totalPriceValue - (discountValue * totalPriceValue);
                    depositPriceValue = totalPriceValue;
                    onsitePriceValue = 0;
                } else {
                    payInAdvanceFormInput.value = '0';
                }

                if (voucherAmountValue > 0) {
                    if (form.getAttribute('data-booking-form') === 'package' && totalPriceValue < 0) {
                        depositPriceValue = 0;
                    }
                }

                console.log(onsitePriceValue);
                // round up values
                depositPriceValue = Math.ceil(depositPriceValue);
                onsitePriceValue = Math.ceil(onsitePriceValue);
                totalPriceValue = Math.ceil(totalPriceValue);

                // free credit
                const freeCreditTable = document.getElementById('booking-reservation__summary-price-table--credit') as HTMLElement | null;
                if (freeCreditTable && totalPriceValue < 0) {
                    freeCreditTable.classList.remove('d-none');
                    const freeCreditValue = freeCreditTable.querySelector('[data-booking-free-credit-value]') as HTMLElement;
                    let creditValue = totalPriceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    creditValue = creditValue.replace('-', '');
                    freeCreditValue.innerHTML = creditValue;

                    if (payInAdvance && payInAdvanceFormInput && payInAdvanceLabel) {
                        if (payInAdvance.checked) {
                            setTimeout(() => {
                                payInAdvance.click();
                                payInAdvance.disabled = true;
                            }, 500);
                        } else {
                            payInAdvance.disabled = true;
                        }

                        depositPriceValue = 0;
                        onsitePriceValue = 0;
                        payInAdvanceLabel.style.display = 'none';
                        payInAdvanceLabel.style.pointerEvents = 'none';
                    }
                } else if (freeCreditTable && payInAdvance && payInAdvanceLabel) {
                    freeCreditTable.classList.add('d-none');
                    payInAdvance.disabled = false;
                    payInAdvanceLabel.style.display = 'flex';
                    payInAdvanceLabel.style.pointerEvents = 'auto';
                }

                // free credit - disable payment
                const payment = document.getElementById('booking-reservation-form__payment') as HTMLElement | null;
                const submitButtonText = document.querySelector('[data-booking-submit-button-subtitle]') as HTMLElement | null;
                if (payment) {
                    if (totalPriceValue <= 0) {
                        // select first radio button
                        const firstRadioButton = form.querySelector('input[type="radio"]') as HTMLInputElement;
                        firstRadioButton.checked = true;
                        payment.classList.add('booking-reservation-form__payment--disabled');
                        submitButtonText?.classList.add('d-none');
                    } else {
                        payment.classList.remove('booking-reservation-form__payment--disabled');
                        submitButtonText?.classList.remove('d-none');
                    }
                }

                // insert new values in format: 1 000 000
                depositPrice.innerHTML = depositPriceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                onsitePrice.innerHTML = onsitePriceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                totalPrice.innerHTML = totalPriceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

                const paymentTotalPriceInputs = form.querySelectorAll('[data-booking-payment-total-price]') as NodeListOf<HTMLElement>;
                paymentTotalPriceInputs.forEach((paymentTotalPriceInput) => {
                    paymentTotalPriceInput.innerHTML = depositPriceValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                });
            }

            // BACK
            const bookingReservation = form.closest('.booking-reservation');
            const backButton = bookingReservation?.querySelector('.booking-reservation-form__button--back');
            const leaveModal = document.querySelector('#booking-leave-modal') as HTMLElement;
            const leaveModalConfirm = leaveModal.querySelector('.booking-leave-modal__confirm') as HTMLLinkElement;

            if (backButton && leaveModal && leaveModalConfirm) {
                backButton.addEventListener('click', () => {
                    leaveModalConfirm.href = backButton.getAttribute('data-href') as string;
                });
            }

            // SUBMIT
            const submitButton = bookingReservation?.querySelector('.booking-reservation__button--submit') as HTMLButtonElement;
            if (!submitButton) return;

            submitButton.addEventListener('click', e => {
                e.preventDefault();

                if (!form.checkValidity()) {
                    let isValid = false;
                    radioButtons.forEach((radioButton) => {
                        const parent = radioButton.closest('.booking-reservation-form__radio-parent');
                        if (!parent) return;

                        if (radioButton.checked) {
                            isValid = true;
                            return;
                        }
                    });

                    if (!isValid) {
                        const radioParent = form.querySelector('.booking-reservation-form__radio-parent') as HTMLElement;
                        radioParent.classList.add('booking-reservation-form__radio-parent--error');
                        return;
                    }

                    form.reportValidity();
                    return;
                }


                let BreakException = {};
                try {
                    const invoiceCheckbox = form.querySelector('[name="invoiceCheckbox"]') as HTMLInputElement;
                    if (invoiceCheckbox.checked) {
                        const invoiceInputs = form.querySelectorAll('#booking-reservation-form__invoiceContainer input') as NodeListOf<HTMLInputElement>;
                        invoiceInputs.forEach((input) => {
                            if (input.value === '') {
                                input.focus();
                                throw BreakException;
                            }
                        });
                    }
                } catch (e) {
                    return;
                }

                const guestCheckbox = form.querySelector('[name="guestCheckbox"]') as HTMLInputElement;
                if (guestCheckbox.checked) {
                    const guestInput = form.querySelector('[name="guestName"]') as HTMLInputElement;
                    if (guestInput.value === '') {
                        guestInput.focus();
                        throw BreakException;
                    }
                }

                submitButton.disabled = true;
                submitButton.innerText = 'Odesílám...';
                form.submit();
            })
        });

    }
}
